export const POSTS_MODERATION_PATH = "/posts-moderation";
